import React from 'react';
import { useFirebaseApp, useUser} from 'reactfire';
import IniciarSesion from '../componentes/IniciarSesion'
import PerfilUsuarioCliente from '../componentes/PerfilUsuarioCliente';

function Usuario(){
    
        return(
            <div className="">
            
            <IniciarSesion/>


            </div>
        )
    
}

export default  Usuario;